import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { getSize, getColor, RichTextEditor } from '@lib/common';
import styled from '@xstyled/styled-components';
import { Checkbox, Tooltip } from 'antd';
import Image from 'next/image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding12'));
var StyledCheckboxWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  margin-top: ", ";\n"])), getSize('padding8'), getSize('padding8'));
var StyledCheckbox = styled(Checkbox)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-self: flex-start;\n\n  .ant-checkbox {\n    top: 0 !important;\n  }\n\n  .ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n    border: 1px solid grey;\n  }\n\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  .ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: ", ";\n  }\n"])), getColor('fillIntActive'), getColor('fillIntActive'), getColor('fillBgWhite'));
var StyledActionButtonWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: #f8fafc;\n    border-color: #1a5aff;\n  }\n"])), getSize('padding4'));
var StyledAnswerEditorWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 1;\n\n  .tiptap {\n    background-color: white !important;\n  }\n"])));
export var AnswerItem = function AnswerItem(_ref) {
  var answer = _ref.answer,
      isCorrectAnswer = _ref.isCorrectAnswer,
      onUpdateAnswer = _ref.onUpdateAnswer,
      onUpdateCorrectAnswer = _ref.onUpdateCorrectAnswer,
      onDelete = _ref.onDelete,
      onAddImage = _ref.onAddImage,
      editorRef = _ref.editorRef,
      readonly = _ref.readonly,
      editorLabels = _ref.editorLabels,
      multipleChoiceLabel = _ref.multipleChoiceLabel;
  return /*#__PURE__*/_jsxs(StyledLayout, {
    children: [/*#__PURE__*/_jsx(StyledCheckboxWrapper, {
      children: /*#__PURE__*/_jsx(StyledCheckbox, {
        checked: isCorrectAnswer,
        onChange: onUpdateCorrectAnswer,
        disabled: readonly
      })
    }), /*#__PURE__*/_jsx(StyledAnswerEditorWrapper, {
      children: /*#__PURE__*/_jsx(RichTextEditor, {
        ref: editorRef,
        content: answer.description || '',
        onChange: onUpdateAnswer,
        placeholder: multipleChoiceLabel.answerDescriptionPlaceholder,
        autoSave: true,
        disabled: readonly,
        addImage: onAddImage,
        editorLabels: editorLabels
      })
    }), onDelete && !readonly && /*#__PURE__*/_jsx(Tooltip, {
      title: multipleChoiceLabel.deleteAnswer,
      placement: "bottom",
      children: /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        onClick: onDelete,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/icons/delete.svg",
          width: 14,
          height: 14,
          alt: "delete"
        })
      })
    })]
  });
};